<template>
  <div class="linexo ocean-theme linexo-mini-result">
    <APriceDisplay :is-loading="isLoading" :is-valid="hasValidResult" :price="price" :is-approximation="true" />
    <ASavingsDisplay :is-loading="isLoading" :is-valid="hasValidResult" :savings="savings" :savings-percentage="savingsPercentage" />
    <LButton
      class="linexo ocean-theme"
      variant="primary"
      append-icon="lnx-open_in_new"
      block
      :aria-label="$t('result.button_redirect')"
      @click="onContactButtonClick"
    >
      {{ $t('result.button_redirect') }}
    </LButton>
  </div>
</template>
<script lang="ts" setup>
import { LButton } from '@wgg.hyve/hyve-ui-library'
import APriceDisplay from '@/components/atoms/display/price/A-PriceDisplay.vue'
import ASavingsDisplay from '@/components/atoms/display/savings/A-SavingsDisplay.vue'
import { PrefillService } from '@/services/prefill.service.ts'
import type { MiniResultProps } from './mini-result.type'

defineProps<MiniResultProps>()

const onContactButtonClick = () => {
  PrefillService.redirectToDefaultCalculator()
}
</script>
<style lang="scss" scoped>
@import './mini-result';
</style>
